export default __webpack_public_path__ + "static/media/yield-farming.af0c8205.svg";